<template>
  <div id="supply-trend" style="height: 145px"></div>
</template>
<script>
import Charts from '@jiaminghi/charts'
export default {
  data() {
    return {
      option: {
        title: { show: false },
        grid: { top: 20, left: 0, right: 0, bottom: 24 },
        legend: {
          data: [
            { name: '产量（万吨）', color: '#e3e067' },
            { name: '产值（亿元）', color: '#4fe916' },
          ],
          textStyle: { fill: '#cfcfcf' },
          top: 15,
          right: 0,
        },
        xAxis: {
          name: '',
          data: [ '2019', '2020', '2021', '2022','2023'],
          axisLabel: {
            formatter: '{value}年',
            style: { fill: '#cfcfcf' },
          },
        },
        yAxis: {
          name: '',
          data: 'value',
          min: 0,
          max: 116,
          interval: 10,
          axisLine: { show: false },
          axisLabel: { show: false },
          axisTick: { show: false },
          splitLine: {
            style: { stroke: '#3f3f3f' },
          },
        },
        series: [
          {
            name: '产量（万吨）',
            stack: 'a',
            data: [28.3, 31.1, 33.5, 32.9, 35.3],
            type: 'bar',
            shapeType: 'leftEchelon',
            label: {
              show: true,
              formatter: '{value}',
              style: { fill: '#e3e067' },
              position: 'bottom',
            },
            gradient: {
              // color: ['#37a2da', '#67e0e3'],
              color: ['rgba(0xda,0xa2,0x37,.75)', 'rgba(0xe3,0xe0,0x67,.2)'],
            },
          },
          {
            name: '产值（亿元）',
            data: [52.2, 61.7, 73.6, 74.8, 108],
            type: 'line',
            lineStyle: { stroke: '#4fe916', lineWidth: 2 },
            label: {
              show: true,
              formatter: '{value}',
              style: { fill: '#4fe916' },
            },
            // gradient: {
            //   color: ['#daa237', '#e3e067'],
            // },
          },
        ],
      },
    }
  },
  mounted() {
    const container = document.getElementById('supply-trend')
    const myChart = new Charts(container)
    myChart.setOption(this.option)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/market-zone/supply-trend.vue